module.exports = __webpack_public_path__ + "img/rank.36d33eff.jpg";